import { useTheme } from '@mui/material';

import {
    useMonthDaySheet,
    statusVisual
} from './statusTokens';

/**
 * One resolved record per day of `yearMonth` (see statusTokens for the
 * precedence rules — present/late/remote > leave > holiday > weekend, absent
 * only on past working days, future days marked 'future').
 */
const useOneMonthTimesheet = (entries, yearMonth, bounds) =>
    useMonthDaySheet(entries, yearMonth, bounds);

/**
 * Colour for a day status. Kept API-compatible with the old hook —
 * `isBgColor` selects the square background, otherwise the text tone.
 */
const usePresentTypeColor = (presentType, isBgColor = false) => {
    const { palette } = useTheme();
    const visual = statusVisual(palette, presentType);
    return isBgColor ? visual.bg : visual.text;
};

export { useOneMonthTimesheet, usePresentTypeColor };
